import axios from "axios";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const authToken = localStorage.getItem("bearerToken");
  useEffect(() => {
    if (authToken) {
      navigate("/");
    }
  }, [authToken, navigate]);

  const handleLogin = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/poc-login`,
        {
          email: email,
          password: password,
        }
      );

      if (response.data.success) {
        const data = response.data;
        const bearerToken = data.token;
        console.log(bearerToken);
        localStorage.setItem("bearerToken", bearerToken);
        localStorage.setItem("email", data.email);
        navigate("/");
        toast.success("User Login successfully!");
        console.log("Response from server:", response.data);
      } else {
        console.log(response);
        toast.error("Error! " + response.data.msg, { toastId: "loginError" });
      }
    } catch (error) {
      console.log("Error during login:", error);
      toast.error("Error Login user. Please try again.");
    }
  };

  const navigateToForgotPassword = () => {
    navigate("/reset_password");
  };

  return (
    <>
      <div className="Login">
        <div className="leftlogin-content">
          <div className="login-maincont">
            <div className="login-tag">
              <h2 className="text-center">Welcome To Octaloop AI Calling Agent</h2>
            </div>
            <div className="input_Fieldss">
              <div className="input_Fieldss1">
                <input
                  type="email"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleLogin();
                    }
                  }}
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="input_Fieldss1" style={{ position: 'relative' }}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleLogin();
                    }
                  }}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute',
                    right: 10,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                  }}
                >
                  {showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
                </span>
              </div>
            </div>

            <div className="login_btn">
              <button
                className="log-btn"
                onClick={handleLogin}
              >
                Log In
              </button>
              <p>
                Don’t have any account?{" "}
                <span
                  className="text-orange-gradient"
                  id="log-In"
                  onClick={() => navigate("/register")}
                >
                  Sign Up
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
